module.exports = __webpack_public_path__ + "static/img/titan_logo.903df67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/titan_logo.png
// module id = tZ8r
// module chunks = 1